"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDescriptorNotFoundInMethodError = exports.OpenRPCDocumentValidationError = exports.ParameterValidationError = exports.MethodCallValidator = exports.MethodNotFoundError = exports.getExtendedMetaSchema = exports.getDocumentExtendedMetaSchema = exports.validateOpenRPCDocument = exports.generateMethodResultId = exports.generateMethodParamId = exports.parseOpenRPCDocument = void 0;
var parse_open_rpc_document_1 = __importDefault(require("./parse-open-rpc-document"));
var validate_open_rpc_document_1 = __importStar(require("./validate-open-rpc-document"));
exports.validateOpenRPCDocument = validate_open_rpc_document_1.default;
Object.defineProperty(exports, "OpenRPCDocumentValidationError", { enumerable: true, get: function () { return validate_open_rpc_document_1.OpenRPCDocumentValidationError; } });
var generate_method_id_1 = require("./generate-method-id");
Object.defineProperty(exports, "generateMethodParamId", { enumerable: true, get: function () { return generate_method_id_1.generateMethodParamId; } });
Object.defineProperty(exports, "generateMethodResultId", { enumerable: true, get: function () { return generate_method_id_1.generateMethodResultId; } });
Object.defineProperty(exports, "ContentDescriptorNotFoundInMethodError", { enumerable: true, get: function () { return generate_method_id_1.ContentDescriptorNotFoundInMethodError; } });
var method_call_validator_1 = require("./method-call-validator");
Object.defineProperty(exports, "MethodCallValidator", { enumerable: true, get: function () { return method_call_validator_1.MethodCallValidator; } });
Object.defineProperty(exports, "ParameterValidationError", { enumerable: true, get: function () { return method_call_validator_1.ParameterValidationError; } });
Object.defineProperty(exports, "MethodNotFoundError", { enumerable: true, get: function () { return method_call_validator_1.MethodNotFoundError; } });
var get_open_rpc_document_from_url_1 = __importDefault(require("./get-open-rpc-document-from-url"));
var get_document_extended_metaschema_1 = __importDefault(require("./get-document-extended-metaschema"));
exports.getDocumentExtendedMetaSchema = get_document_extended_metaschema_1.default;
var get_extended_metaschema_1 = __importDefault(require("./get-extended-metaschema"));
exports.getExtendedMetaSchema = get_extended_metaschema_1.default;
var noop = function (schema) {
    return Promise.reject("Not Implemented, passed: ".concat(schema));
};
var parseOpenRPCDocument = (0, parse_open_rpc_document_1.default)(get_open_rpc_document_from_url_1.default, noop);
exports.parseOpenRPCDocument = parseOpenRPCDocument;
